export const WARRANTY_FORM_SUBMIT = "warranty_form_submit"
export const CREATE_WARRANTY = "create_warranty"
export const WARRANTY_BEGIN = "warranty_begin"
export const WARRANTY_SUCCESS = "warranty_success"
export const CLEAR_WARRANTY_FORM = "clear_warranty_form"